<template>
  <ModalConfirmation
    :isShowConfirmDeleteMessage="false"
    :appendToBody="true"
    customWidth="420px"
    :ariaLabel="title"
    @close="$emit('close')">
    <h3 slot="item">{{ title }}</h3>
    <template slot="custom_warning">
      <p class="onward-confirm__intro">{{ applyOnwardsText }}</p>
      <div class="onward-confirm__toggle" @click.stop="toggleEndDate">
        <AppToggle :propOn="hasEndDate" :allowChanges="false"></AppToggle>
        <label>{{ i18n.choose_end_date }}</label>
      </div>
      <div class="onward-confirm__date" v-if="hasEndDate">
        <DateSelector
          :date="enddate"
          :minDate="minDate"
          :width100="true"
          @changed="setEndDate">
        </DateSelector>
      </div>
    </template>
    <template slot="confirm_buttons">
      <button @click.stop="$emit('close')">{{ i18n.cancel }}</button>
      <button
        class="bttn"
        :class="{'bttn-danger': mode === 'remove'}"
        @click.stop="onConfirm">
        {{ confirmLabel }}
      </button>
    </template>
  </ModalConfirmation>
</template>

<script>
import ModalConfirmation from '../Modals/ModalConfirmation'
import AppToggle from '../common/AppToggle'
import DateSelector from '../datepicker/DateSelector'
import moment from 'moment'

const I18N = {
  da: {
    choose_end_date: 'Vælg slutdato',
    cancel: 'Annuller',
    apply_remove: 'Fjernes fra alle skemalagte brikker fremadrettet',
    apply_add: 'Sættes på alle skemalagte brikker fremadrettet',
    apply_replace: 'Erstattes på alle skemalagte brikker fremadrettet',
    apply_remove_until: 'Fjernes fra alle skemalagte brikker frem til og med d. %{date}',
    apply_add_until: 'Sættes på alle skemalagte brikker frem til og med d. %{date}',
    apply_replace_until: 'Erstattes på alle skemalagte brikker frem til og med d. %{date}',
    title_remove: 'Fjern fremadrettet',
    title_add: 'Tilføj fremadrettet',
    title_replace: 'Erstat fremadrettet',
    confirm_remove: 'Fjern',
    confirm_add: 'Tilføj',
    confirm_replace: 'Erstat'
  },
  en: {
    choose_end_date: 'Choose end date',
    cancel: 'Cancel',
    apply_remove: 'Removed from all scheduled lessons going forward',
    apply_add: 'Added to all scheduled lessons going forward',
    apply_replace: 'Replaced on all scheduled lessons going forward',
    apply_remove_until: 'Removed from all scheduled lessons until and including %{date}',
    apply_add_until: 'Added to all scheduled lessons until and including %{date}',
    apply_replace_until: 'Replaced on all scheduled lessons until and including %{date}',
    title_remove: 'Remove onwards',
    title_add: 'Add onwards',
    title_replace: 'Replace onwards',
    confirm_remove: 'Remove',
    confirm_add: 'Add',
    confirm_replace: 'Replace'
  },
  nb: {
    choose_end_date: 'Velg sluttdato',
    cancel: 'Avbryt',
    apply_remove: 'Fjernes fra alle timeplanlagte brikker fremover',
    apply_add: 'Settes på alle timeplanlagte brikker fremover',
    apply_replace: 'Erstattes på alle timeplanlagte brikker fremover',
    apply_remove_until: 'Fjernes fra alle timeplanlagte brikker frem til og med %{date}',
    apply_add_until: 'Settes på alle timeplanlagte brikker frem til og med %{date}',
    apply_replace_until: 'Erstattes på alle timeplanlagte brikker frem til og med %{date}',
    title_remove: 'Fjern fremover',
    title_add: 'Legg til fremover',
    title_replace: 'Erstatt fremover',
    confirm_remove: 'Fjern',
    confirm_add: 'Legg til',
    confirm_replace: 'Erstatt'
  }
}

export default {
  components: {ModalConfirmation, AppToggle, DateSelector},
  props: {
    mode: {
      type: String,
      default: 'remove'
    },
    calendarName: {
      type: String,
      default: ''
    },
    minDate: {
      default: null
    }
  },
  data () {
    return {
      hasEndDate: false,
      enddate: null
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale] || I18N.da
    },
    title () {
      return this.i18n['title_' + this.mode] || this.i18n.title_remove
    },
    formattedEndDate () {
      if (!this.enddate) return ''
      return moment(this.enddate).locale(this.locale).format('D. MMMM')
    },
    applyOnwardsText () {
      if (this.hasEndDate && this.enddate) {
        const template = this.i18n['apply_' + this.mode + '_until'] || this.i18n.apply_remove_until
        return template.replace('%{date}', this.formattedEndDate)
      }
      return this.i18n['apply_' + this.mode] || this.i18n.apply_remove
    },
    confirmLabel () {
      const action = this.i18n['confirm_' + this.mode] || this.i18n.confirm_remove
      return this.calendarName ? action + ' ' + this.calendarName : action
    }
  },
  methods: {
    defaultEnddate () {
      return moment(this.minDate || undefined).format('YYYY-MM-DD')
    },
    toggleEndDate () {
      this.hasEndDate = !this.hasEndDate
      this.enddate = this.hasEndDate ? this.defaultEnddate() : null
    },
    setEndDate (date) {
      this.enddate = moment(date).format('YYYY-MM-DD')
    },
    onConfirm () {
      this.$emit('confirm', this.hasEndDate ? this.enddate : null)
    }
  }
}
</script>

<style scoped>
.onward-confirm__intro {
  padding: 0 1rem 1rem;
  margin: 0;
}

.onward-confirm__toggle {
  display: flex;
  align-items: center;
  padding: 0 1rem 1rem;
  cursor: pointer;
  user-select: none;
}

.onward-confirm__toggle label {
  margin: 0 0 0 10px;
  cursor: pointer;
}

.onward-confirm__date {
  padding: 0 1rem 1rem;
}
</style>



// WEBPACK FOOTER //
// CalendarViewDayOnwardConfirm.vue?7591712a